import React, { useState, useEffect } from 'react';
import { BiLogoWhatsapp } from 'react-icons/bi';
import './WhatsAppChat.scss'; // Assuming SCSS file is named like this

const WhatsAppChatModel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const sendMessage = () => { 
    const phoneNumber = '919677177296';
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="container-whatsapp">
      {showButton && (
        <div className="whatsapp-button" onClick={toggleChat}>
          <BiLogoWhatsapp size={32} />
        </div>
      )}

      {isOpen && (
        <div className="chat-box">
          <div className="header">
            <img src="/header/logo-mobile.png" alt="Support" className="avatar" />
            <div>
              <h4 style={{ margin: 0 }}>Mygen Global</h4>
              <p style={{ margin: 0, fontSize: '12px', color: 'green' }}>🟢 Online</p>
            </div>
          </div>
          <div className="welcome">
            <p>👋 Hi there! How can we assist you today?</p>
          </div>
          <textarea
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button onClick={sendMessage} className="send-button">
            Start Chat
          </button>
        </div>
      )}
    </div>
  );
};

export default WhatsAppChatModel;
